import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { LogOut, Users, Video, Settings as SettingsIcon } from 'lucide-react';
import VideosTable from '../components/admin/VideosTable';
import UsersTable from '../components/admin/UsersTable';
import SettingsForm from '../components/admin/SettingsForm';

const AdminPanel = () => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 md:mb-8 gap-4">
          <h1 className="text-2xl md:text-3xl font-bold">Admin Panel</h1>
          <div className="flex flex-wrap gap-2 md:gap-4 w-full md:w-auto">
            <span className="text-sm text-gray-600 self-center w-full md:w-auto text-center md:text-left">
              Welcome, {user?.name || user?.email}
            </span>
            <Button onClick={() => navigate('/')} variant="outline" className="flex-1 md:flex-none">
              View Site
            </Button>
            <Button onClick={handleLogout} variant="outline" className="flex items-center gap-2 flex-1 md:flex-none">
              <LogOut className="w-4 h-4" />
              Logout
            </Button>
          </div>
        </div>

        <Tabs defaultValue="videos" className="w-full">
          <TabsList className={`grid w-full mb-6 md:mb-8 ${user?.role === 'admin' ? 'grid-cols-3' : 'grid-cols-1'}`}>
            <TabsTrigger value="videos" className="flex items-center gap-2 text-sm md:text-base">
              <Video className="w-4 h-4" />
              Videos
            </TabsTrigger>
            {user?.role === 'admin' && (
              <>
                <TabsTrigger value="users" className="flex items-center gap-2 text-sm md:text-base">
                  <Users className="w-4 h-4" />
                  Users
                </TabsTrigger>
                <TabsTrigger value="settings" className="flex items-center gap-2 text-sm md:text-base">
                  <SettingsIcon className="w-4 h-4" />
                  Settings
                </TabsTrigger>
              </>
            )}
          </TabsList>

          <TabsContent value="videos">
            <VideosTable />
          </TabsContent>

          {user?.role === 'admin' && (
            <TabsContent value="users">
              <UsersTable currentUser={user} />
            </TabsContent>
          )}

          {user?.role === 'admin' && (
            <TabsContent value="settings">
              <SettingsForm />
            </TabsContent>
          )}
        </Tabs>
      </div>
    </div>
  );
};

export default AdminPanel;
